document.addEventListener('DOMContentLoaded', function() {
  const videoSections = document.querySelectorAll('.videoSection');
  let initialX = null;
  let moveX = 0;
  const MOVE_THRESHOLD = 10;


  videoSections.forEach((section) => {
    const videoContainer = section.querySelector('.videoContainer');
    const videos = videoContainer.querySelectorAll('video');
    const prevBtn = section.querySelector('#prevBtn');
    const nextBtn = section.querySelector('#nextBtn');
    const dots = section.querySelectorAll('.customDot');
  
    let currentVideoIndex = 0;

    function updateCarousel() {
      const videoWidth = videos[0].offsetWidth;
      if(currentVideoIndex === videos.length - 1) {
        videoContainer.style.transform = `translateX(-${currentVideoIndex * ((videoWidth / 1.16) + 10)}px)`;
      } else {
        videoContainer.style.transform = `translateX(-${currentVideoIndex * (videoWidth + 10)}px)`;
      }
      dots[0].classList.add('customDot-selected');
    }

    nextBtn.addEventListener('click', function() {
      swipeLeft()
    });

    prevBtn.addEventListener('click', function() {
      swipeRight()
    });

    videoContainer.addEventListener('touchstart', startTouch, false);
    videoContainer.addEventListener('touchmove', moveTouch, false);
    videoContainer.addEventListener('touchend', endTouch, false);

    function startTouch(e) {
      initialX = e.touches[0].clientX;
    }

    function moveTouch(e) {
      if (initialX === null) return;
  
      const currentX = e.touches[0].clientX;
      moveX = currentX - initialX;
    }

    function endTouch(e) {
      if (initialX === null) return;
  
      if (Math.abs(moveX) > MOVE_THRESHOLD) {
          if (moveX > 0) {
              swipeRight();
          } else {
              swipeLeft();
          }
      }
  
      initialX = null;
    }

    function swipeLeft() {
        if (currentVideoIndex < videos.length - 1) {
        currentVideoIndex++;
        updateCarousel();
      }

      dots.forEach((dot, index) => {
        if (index === currentVideoIndex) {
          dot.classList.add('customDot-selected');
        } else {
          dot.classList.remove('customDot-selected');
        }
      });
    }
    
    function swipeRight() {
        if (currentVideoIndex > 0) {
        currentVideoIndex--;
        updateCarousel();
      }
      dots.forEach((dot, index) => {
        if (index === currentVideoIndex) {
          dot.classList.add('customDot-selected');
        } else {
          dot.classList.remove('customDot-selected');
        }
      });
    }

    updateCarousel();
  });
});